"use client";

import { OutboundLink } from "@/features/outbound-link/outbound-link";
import { withBasePath } from "@/lib/base-path";
import { BiEvent } from "@/lib/bi/bi.enum";
import { cn } from "@/lib/utils";

import { usePrimeDayCountdown } from "../../hooks/use-prime-day-countdown";
import { CountdownDigits } from "../countdown-digits";

type Props = {
  className?: string;
  primeDayUrl: string;
};

export function BannerTop({ className, primeDayUrl }: Props) {
  const { hours, minutes, seconds } = usePrimeDayCountdown();

  return (
    <OutboundLink
      url={primeDayUrl}
      storeName="Amazon"
      bi={{
        eventType: BiEvent.BannerOutbound,
        provider: "amazon",
        location: "prime-day-banner",
      }}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "h-11 overflow-hidden",
        "flex items-center justify-center",
        "bg-[#e6f4ff] border-b-2 border-[#fda337] shadow-[0px_4px_8px_0px_rgba(199,199,199,0.25)]",
        "text-[#216eb4] sub2",
        className,
      )}
    >
      <div className="flex gap-x-2 items-baseline">
        <span className="relative">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={withBasePath("/prime-day/bags.svg")}
            aria-hidden="true"
            alt=""
            width={50}
            height={48}
            className="absolute -top-[10px] -left-[46px]"
          />
          <span>Prime Day sale</span>
        </span>
        <span className="inline-flex items-center gap-0.5">
          <CountdownDigits
            value={hours}
            label="Hrs"
          />
          <CountdownDigits
            value={minutes}
            label="Min"
          />
          <CountdownDigits
            value={seconds}
            label="Sec"
          />
        </span>
      </div>
    </OutboundLink>
  );
}
